export const HTTP_ERROR_STATUS = {
  INTERNAL_SERVER_ERROR: 500,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  CONFLICT: 409,
};

export const ERROR_CODES = {
  INTERNAL_SERVER_ERROR: 1000, // Внутрішні помилки сервісу, а також помилки, отримані від зовнішніх систем, з HttpStatus 500 (INTERNAL_SERVER_ERROR)
  INVALID_ARGUMENTS: 1002, // Невалідні аргументи методу (наприклад, неможливо розібрати розширення переданого файлу)
  SIGNATURE_VALIDATION_ERROR: 1003, // Помилка валідації підпису документів
  MULTI_SIGNERS_NOT_SUPPORTED: 1010, // Multi-signers signature is currently not supported
  YOU_SCORE_API_ERROR: 1200, // Помилка АРІ you-score
  YOU_SCORE_UPDATE_ERROR: 1201, // Помилка оновлення АРІ you-score
  YOU_SCORE_UNKNOWN_ERROR: 1202,
  STRABIS_API_ERROR: 1300, // Помилка АРІ strabis
  EDR_NAIS_API_ERROR: 1400, // Помилка АРІ edr-nais
  STATUS_ERROR: 1401, // Помилка cтатусу
  DATA_NOT_FOUND_EDR: 1402, // Дані не було знайдено
  MANAGER_NOT_FOUND: 1403, // Дані не було знайдено по керівнику
  MANAGER_NOT_FOUND_B2: 1501, // Не знайдено керівника в Б2
  INVALID_OTP: 1012, // ОТП блокування користувача
  BLOCKING_OTP: 1013, // ОТП блокування користувача
  DATA_NOT_FOUND: 1700, // Дані не знайдено
  DUPLICATE_APPLICATION: 1701, // За даним ІПН вже зареєстрована заявка
  CLIENT_TYPE_ERROR: 1702, // Помилка, пов'язана з типом клієнта
  APPLICATION_SEARCH_ERROR: 1703, // Помилка, пов'язана з пошуком заявки
  SIGNATURE_INIT_ERROR: 1800, // Помилка, пов'язана з ініціалізацією підпису
  DOCUMENT_FETCH_FAILED: 1801, // На жаль, не вдалося отримати документи. Спробуйте ще раз
  DOCUMENTS_HAVE_NOT_ARRIVED: 1802, // На жаль, не передались документи
  DOCUMENT_NOT_FOUND: 1803, // Немає файлів для підпису
  DOCUMENTS_LIMIT_EXCEEDED: 1804, // Перевищено ліміт документів у заявці
  DATA_NOT_FOUND_TOBO: 2500, // tobo по контрагенту ******* не знайдено
  SUCH_USER_ALREADY_EXISTS: 1500, // Користувач з логіном ****** вже існує
  COUNTERPARTY_ALREADY_EXISTS: 1505,
  TEMPLATE_NOT_FOUND: 2008, // Шаблон не знайдено
};

export const EMPTY_ERROR = {
  errorMessage: null,
};
